// import React from 'react';
import styled from 'styled-components'

import PropTypes from 'prop-types';
import {Heading, Text} from 'rebass';
// import { MobileHeader, DesktopBox, Content} from "../../components/Base";


export const PageTitle = styled(Heading)`
	font-size: 32px;
	font-weight: 800;

	& > span {
		color: #969a9b;
	}

	@media(max-width: 700px) {
		font-size: 24px;
		padding-bottom: 8px;
	}
`;

PageTitle.propTypes = {
	color: PropTypes.string
};

PageTitle.defaultProps = {
	color: '#263039'
};

export const MobileHeaderTitle = styled(Heading)`
font-size: 21px;
font-weight: 800;
 & > span {
    color: #969a9b;
 }
`;

MobileHeaderTitle.propTypes = {
	color: PropTypes.string
};

MobileHeaderTitle.defaultProps = {
	color: '#263039'
};

export const PageSubTitle = styled(Text)`
font-size: 15px;
// font-weight: 600px;
font-weight: normal;
//color: #969a9b;
 & > span {
    color: #969a9b;
 }
`;

PageTitle.propTypes = {
	color: PropTypes.string
};

PageTitle.defaultProps = {
	color: 'metaText'
};

export const CardTitle = styled(Text)`
font-size: 17px;
font-weight: 700;
color: #263039;
`;

export const MetaText = styled(Text)`
font-size: 12px;
`;

MetaText.propTypes = {
	color: PropTypes.string,
	fontWeight: PropTypes.number
};

MetaText.defaultProps = {
	color: 'metaText',
	fontWeight: 600
};
